import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Import_templates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.import_templates_Id,
          sortable: true,
          cell: (row) => <span>{row.import_templates_Id}</span>,
        },
        { name: "Template Code", selector: (row, i) => row.template_code, sortable: true, cell: (row) => <span>{row.template_code}</span>, }, { name: "Template Name", selector: (row, i) => row.template_name, sortable: true, cell: (row) => <span>{row.template_name}</span>, }, { name: "Template Description", selector: (row, i) => row.template_description, sortable: true, cell: (row) => <span>{row.template_description}</span>, }, { name: "Target Table", selector: (row, i) => row.target_table, sortable: true, cell: (row) => <span>{row.target_table}</span>, }, { name: "Mapping Config", selector: (row, i) => row.mapping_config, sortable: true, cell: (row) => <span>{row.mapping_config}</span>, }, { name: "Validation Config", selector: (row, i) => row.validation_config, sortable: true, cell: (row) => <span>{row.validation_config}</span>, }, { name: "Duplicate Check Config", selector: (row, i) => row.duplicate_check_config, sortable: true, cell: (row) => <span>{row.duplicate_check_config}</span>, }, { name: "Transformation Config", selector: (row, i) => row.transformation_config, sortable: true, cell: (row) => <span>{row.transformation_config}</span>, }, { name: "Sample File Path", selector: (row, i) => row.sample_file_path, sortable: true, cell: (row) => <span>{row.sample_file_path}</span>, }, { name: "Is Active", selector: (row, i) => row.is_active, sortable: true, cell: (row) => <span>{row.is_active}</span>, }, { name: "Is Public", selector: (row, i) => row.is_public, sortable: true, cell: (row) => <span>{row.is_public}</span>, }, { name: "Usage Count", selector: (row, i) => row.usage_count, sortable: true, cell: (row) => <span>{row.usage_count}</span>, }, { name: "Last Used On", selector: (row, i) => row.last_used_on, sortable: true, cell: (row) => <span>{row.last_used_on}</span>, },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Import_templateseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      import_templates_Id: "",
      template_code: '', template_name: '', template_description: '', target_table: '', mapping_config: '', validation_config: '', duplicate_check_config: '', transformation_config: '', sample_file_path: '', is_active: '', is_public: '', usage_count: '', last_used_on: '',

    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'template_code', inputType: 'Text', displayName: 'Template Code', validationOptions: { isRequired: false } },
      { fieldName: 'template_name', inputType: 'Text', displayName: 'Template Name', validationOptions: { isRequired: false } },
      { fieldName: 'template_description', inputType: 'Text', displayName: 'Template Description', validationOptions: { isRequired: false } },
      { fieldName: 'target_table', inputType: 'Text', displayName: 'Target Table', validationOptions: { isRequired: false } },
      { fieldName: 'mapping_config', inputType: 'Text', displayName: 'Mapping Config', validationOptions: { isRequired: false } },
      { fieldName: 'validation_config', inputType: 'Text', displayName: 'Validation Config', validationOptions: { isRequired: false } },
      { fieldName: 'duplicate_check_config', inputType: 'Text', displayName: 'Duplicate Check Config', validationOptions: { isRequired: false } },
      { fieldName: 'transformation_config', inputType: 'Text', displayName: 'Transformation Config', validationOptions: { isRequired: false } },
      { fieldName: 'sample_file_path', inputType: 'Text', displayName: 'Sample File Path', validationOptions: { isRequired: false } },
      { fieldName: 'is_active', inputType: 'Number', displayName: 'Is Active', validationOptions: { isRequired: false } },
      { fieldName: 'is_public', inputType: 'Number', displayName: 'Is Public', validationOptions: { isRequired: false } },
      { fieldName: 'usage_count', inputType: 'Number', displayName: 'Usage Count', validationOptions: { isRequired: false } },
      { fieldName: 'last_used_on', inputType: 'Date', displayName: 'Last Used On', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      template_code: '', template_name: '', template_description: '', target_table: '', mapping_config: '', validation_config: '', duplicate_check_config: '', transformation_config: '', sample_file_path: '', is_active: '', is_public: '', usage_count: '', last_used_on: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      template_code: '', template_name: '', template_description: '', target_table: '', mapping_config: '', validation_config: '', duplicate_check_config: '', transformation_config: '', sample_file_path: '', is_active: '', is_public: '', usage_count: '', last_used_on: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Import_templateseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      import_templates_Id: row.import_templates_Id,
      template_code: row.template_code, template_name: row.template_name, template_description: row.template_description, target_table: row.target_table, mapping_config: row.mapping_config, validation_config: row.validation_config, duplicate_check_config: row.duplicate_check_config, transformation_config: row.transformation_config, sample_file_path: row.sample_file_path, is_active: row.is_active, is_public: row.is_public, usage_count: row.usage_count, last_used_on: row.last_used_on,

      errors: {},
      touched: {}
    });
  }

  Import_templatesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Import_templates/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Import_templatessubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('template_code', this.state.template_code);
    formData.append('template_name', this.state.template_name);
    formData.append('template_description', this.state.template_description);
    formData.append('target_table', this.state.target_table);
    formData.append('mapping_config', this.state.mapping_config);
    formData.append('validation_config', this.state.validation_config);
    formData.append('duplicate_check_config', this.state.duplicate_check_config);
    formData.append('transformation_config', this.state.transformation_config);
    formData.append('sample_file_path', this.state.sample_file_path);
    formData.append('is_active', this.state.is_active);
    formData.append('is_public', this.state.is_public);
    formData.append('usage_count', this.state.usage_count);
    formData.append('last_used_on', this.state.last_used_on);



    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Import_templates/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_templatesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ template_code: '', template_name: '', template_description: '', target_table: '', mapping_config: '', validation_config: '', duplicate_check_config: '', transformation_config: '', sample_file_path: '', is_active: '', is_public: '', usage_count: '', last_used_on: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Import_templatesupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("import_templates_Id", this.state.import_templates_Id);
    formData.append('template_code', this.state.template_code);
    formData.append('template_name', this.state.template_name);
    formData.append('template_description', this.state.template_description);
    formData.append('target_table', this.state.target_table);
    formData.append('mapping_config', this.state.mapping_config);
    formData.append('validation_config', this.state.validation_config);
    formData.append('duplicate_check_config', this.state.duplicate_check_config);
    formData.append('transformation_config', this.state.transformation_config);
    formData.append('sample_file_path', this.state.sample_file_path);
    formData.append('is_active', this.state.is_active);
    formData.append('is_public', this.state.is_public);
    formData.append('usage_count', this.state.usage_count);
    formData.append('last_used_on', this.state.last_used_on);



    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Import_templates/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_templatesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Import_templatesfetchHandler();


  }

  handletemplate_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ template_code: fieldValue });
  }; handletemplate_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ template_name: fieldValue });
  }; handletemplate_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ template_description: fieldValue });
  }; handletarget_tableChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ target_table: fieldValue });
  }; handlemapping_configChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mapping_config: fieldValue });
  }; handlevalidation_configChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ validation_config: fieldValue });
  }; handleduplicate_check_configChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ duplicate_check_config: fieldValue });
  }; handletransformation_configChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ transformation_config: fieldValue });
  }; handlesample_file_pathChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sample_file_path: fieldValue });
  }; handleis_activeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ is_active: fieldValue });
  }; handleis_publicChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ is_public: fieldValue });
  }; handleusage_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ usage_count: fieldValue });
  }; handlelast_used_onChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ last_used_on: fieldValue });
  };


  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this import_templates?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('import_templates_Id', row.import_templates_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Import_templates/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_templatesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Import Templates</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Import_templates</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Template Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletemplate_codeChange} className="form-control" name="template_code" value={this.state.template_code} required="required" placeholder="Enter template_code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Template Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletemplate_nameChange} className="form-control" name="template_name" value={this.state.template_name} required="required" placeholder="Enter template_name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Template Description</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletemplate_descriptionChange} className="form-control" name="template_description" value={this.state.template_description} required="required" placeholder="Enter template_description" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_description} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Target Table</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletarget_tableChange} className="form-control" name="target_table" value={this.state.target_table} required="required" placeholder="Enter target_table" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_table} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Mapping Config</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemapping_configChange} className="form-control" name="mapping_config" value={this.state.mapping_config} required="required" placeholder="Enter mapping_config" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapping_config} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Validation Config</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlevalidation_configChange} className="form-control" name="validation_config" value={this.state.validation_config} required="required" placeholder="Enter validation_config" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.validation_config} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Duplicate Check Config</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleduplicate_check_configChange} className="form-control" name="duplicate_check_config" value={this.state.duplicate_check_config} required="required" placeholder="Enter duplicate_check_config" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.duplicate_check_config} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Transformation Config</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletransformation_configChange} className="form-control" name="transformation_config" value={this.state.transformation_config} required="required" placeholder="Enter transformation_config" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.transformation_config} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Sample File Path</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesample_file_pathChange} className="form-control" name="sample_file_path" value={this.state.sample_file_path} required="required" placeholder="Enter sample_file_path" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sample_file_path} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleis_activeChange} className="form-control" name="is_active" value={this.state.is_active} required="required" placeholder="Enter is_active" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Public</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleis_publicChange} className="form-control" name="is_public" value={this.state.is_public} required="required" placeholder="Enter is_public" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_public} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Usage Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleusage_countChange} className="form-control" name="usage_count" value={this.state.usage_count} required="required" placeholder="Enter usage_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.usage_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Last Used On</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlelast_used_onChange} className="form-control" name="last_used_on" value={this.state.last_used_on} required="required" placeholder="Enter last_used_on" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.last_used_on} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Import_templatessubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Import_templates</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Template Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletemplate_codeChange} className="form-control" name="template_code" value={this.state.template_code} required="required" placeholder="Enter template_code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Template Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletemplate_nameChange} className="form-control" name="template_name" value={this.state.template_name} required="required" placeholder="Enter template_name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Template Description</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletemplate_descriptionChange} className="form-control" name="template_description" value={this.state.template_description} required="required" placeholder="Enter template_description" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.template_description} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Target Table</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletarget_tableChange} className="form-control" name="target_table" value={this.state.target_table} required="required" placeholder="Enter target_table" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_table} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Mapping Config</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemapping_configChange} className="form-control" name="mapping_config" value={this.state.mapping_config} required="required" placeholder="Enter mapping_config" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapping_config} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Validation Config</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlevalidation_configChange} className="form-control" name="validation_config" value={this.state.validation_config} required="required" placeholder="Enter validation_config" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.validation_config} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Duplicate Check Config</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleduplicate_check_configChange} className="form-control" name="duplicate_check_config" value={this.state.duplicate_check_config} required="required" placeholder="Enter duplicate_check_config" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.duplicate_check_config} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Transformation Config</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletransformation_configChange} className="form-control" name="transformation_config" value={this.state.transformation_config} required="required" placeholder="Enter transformation_config" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.transformation_config} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Sample File Path</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesample_file_pathChange} className="form-control" name="sample_file_path" value={this.state.sample_file_path} required="required" placeholder="Enter sample_file_path" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sample_file_path} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleis_activeChange} className="form-control" name="is_active" value={this.state.is_active} required="required" placeholder="Enter is_active" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_active} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Public</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleis_publicChange} className="form-control" name="is_public" value={this.state.is_public} required="required" placeholder="Enter is_public" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_public} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Usage Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleusage_countChange} className="form-control" name="usage_count" value={this.state.usage_count} required="required" placeholder="Enter usage_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.usage_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Last Used On</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlelast_used_onChange} className="form-control" name="last_used_on" value={this.state.last_used_on} required="required" placeholder="Enter last_used_on" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.last_used_on} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Import_templatesupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}